declare namespace $ {

	export class $mol_icon_account_remove extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=remove.view.tree.d.ts.map